import { render, staticRenderFns } from "./MDFeForm.vue?vue&type=template&id=731783a6"
import script from "./MDFeForm.vue?vue&type=script&lang=js"
export * from "./MDFeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports